<template>
  <div class="register-agreement-checkbox-div">
    <input type="checkbox"
           id="register"
           class="register-agreement-checkbox"
           :checked="agreed"
           @click="agreementClicked">
    <label class="register-agreement-label" for="register"> 同意</label>
    <a target="_blank" class="register-agreement-a" href="http://reg.lingxi360.com/register/agreement">《灵析用户注册/使用条款》</a>
  </div>

</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .register-agreement-checkbox-div
    margin-top: 3px
    line-height: siz(13)
    height: siz(15)
    vertical-align: middle
    font-size: siz(11)
  .register-agreement-checkbox
    vertical-align: middle
    line-height: siz(13)
    height: siz(15)
    position: relative
    bottom: 1px
  .register-agreement-label
    display:inline-block
    line-height: siz(13)
    height: siz(15)
  .register-agreement-a
    text-decoration: underline
    color: login-blue
    font-size: siz(11)
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'

  export default {
    computed: {
      agreed () {
        return this.$store.state.login.agreed
      }
    },
    methods: {
      agreementClicked () {
        this.$store.commit(mTypes.LOGIN_UPDATE, { agreed: !this.agreed })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RegisterAgreement.vue?3d1fdea2